import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { MarcaDTO } from 'service/apicataleg/types/ApiCatalegTypes';

type MarcaSliceState = {
  marques: Array<MarcaDTO>;
  selected: MarcaDTO | null;
};

const key = 'payloadMarques';
const marca = localStorage.getItem(key);

const emptyState = { marques: [], selected: null };
const initialState: MarcaSliceState = marca ? JSON.parse(marca) : emptyState;

export const MarcaSlice = createSlice({
  name: key,
  initialState,
  reducers: {
    setSelectedMarca: (state, { payload }) => {
      const { selected, ...data } = state;
      const newState = { ...data, selected: payload };
      localStorage.setItem(key, JSON.stringify(newState));
      return newState;
    },

    setMarques: (state, action: PayloadAction<Array<MarcaDTO>>) => {
      const marques = action.payload;

      const marcaRAS = action.payload.find((x) => x.codi === 'RAS');
      const selected = marcaRAS || marques[0] || null;
      const newState = { marques, selected };
      localStorage.setItem(key, JSON.stringify(newState));
      return newState;
    },

    clearMarques: (state) => {
      localStorage.setItem(key, JSON.stringify(emptyState));
      return emptyState;
    },
  },
});

export const { setSelectedMarca, setMarques, clearMarques } = MarcaSlice.actions;
export default MarcaSlice.reducer;
